import Home from './views/Home';

import { HomeIcon } from './components/Icons/Icons';

export const main = [
  {
    path: '/',
    name: 'Home',
    icon: <HomeIcon color="inherit" />,
    component: Home,
    layout: '/',
  },
];

export const account = [];

export const header = [];


const routes = [...main, ...account, ...header];
export default routes;
